import Api from '@/services/api.js'

export default {
  addDocket(docket) {
    return Api.post('dockets/add', docket)
  },
  checkDocket(docket) {
    return Api.post('dockets/checkDocket', docket)
  },
  updateDocket(docket) {
    var id = docket.id
    return Api.put(`dockets/${id}`, docket)
  },
  getAllDockets() {
    return Api.get('dockets/')
  },
  deleteAllDockets() {
    return Api.delete('dockets/')
  },
  deleteDocket(id) {
    return Api.delete(`dockets/${id}`)
  },

  addTrip(trip) {
    return Api.post('dockets/trips', trip)
  },

  getUnconfirmedTrips(payload) {
    return Api.post(`dockets/trips/unconfirmed`, payload)
  },
  getConfirmedTrips(payload) {
    return Api.post(`dockets/trips/confirmed/${payload.type}`, payload)
  },
  getPreviewData(payload) {
    return Api.post(`dockets/trips/previewData/${payload.type}`, payload)
  },

  updateTripField(payload) {
    return Api.put(`dockets/trips/${payload.id}/${payload.field}`, payload)
  },
  updateTrip(trip) {
    var id = trip.id
    return Api.put(`dockets/trips/${id}`, trip)
  },
  updateTrips(trips) {
    return Api.patch(`dockets/trips`, trips)
  },
  deleteTrip(id) {
    return Api.delete(`dockets/trips/${id}`)
  },
  getTripsByDocket(id) {
    return Api.get(`dockets/trips/byDocket/${id}`)
  },
  getTripsByRcti(rcti) {
    return Api.get(`dockets/trips/byRcti/${rcti}`)
  },
  getTripsByBill(id, payload) {
    return Api.post(`dockets/trips/byBill/${id}`, payload)
  },
  getDocketsBy(payload) {
    return Api.post('dockets/getBy', payload)
  },

  importDockets(file) {
    return Api.post('dockets/import', file)
  },

  batchRepriceTrips(payload) {
    return Api.patch('dockets/trips/batchReprice', payload)
  }
}
